/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type { GetUnreadNotificationsCountQueryResponse } from '../types/GetUnreadNotificationsCount'

function getGetUnreadNotificationsCountUrl() {
  const res = {
    method: 'GET',
    url: `/api/v1/notifications/unread-count/` as const,
  }
  return res
}

/**
 * @summary Count of unread notifications for the current user
 * {@link /api/v1/notifications/unread-count/}
 */
export async function getUnreadNotificationsCount(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetUnreadNotificationsCountQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getGetUnreadNotificationsCountUrl().url.toString(),
    ...requestConfig,
  })
  return res.data
}
